export default "__VITE_ASSET__B02dRWcj__"